export default "__VITE_ASSET__BCAzF9Ak__"